module.exports = "data:text/x-markdown;base64,Q29uZ3JhdHMhCgpZb3UgYXJlIGEgcmV2ZXJzaW5nIGVuZ2luZWVyIG1hc3RlciBub3chCg=="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/strongBox_complete.md
// module id = 1408
// module chunks = 0